<template>
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-all duration-200">
    <div class="p-5">
      <div class="flex justify-between items-start mb-4">
        <div class="flex items-center gap-3">
          <div class="bg-gray-100 dark:bg-gray-700 p-2 rounded-lg">
            <Building2 class="h-5 w-5 text-gray-600 dark:text-gray-300" />
          </div>
          <div>
            <h2 class="font-semibold text-gray-800 dark:text-gray-200">{{ unidade?.link?.unidade_nome || unidade?.unidade_nome || unidade?.hostname || 'Desconhecido' }}</h2>
          </div>
        </div>
        <span class="flex items-center mt-2 gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
          <component :is="getStatusIcon(statusText(status))" 
                     :class="getStatusIconColor(statusText(status))" class="h-5 w-5" />
          <span class="hidden md:inline">
            {{ statusText(status) }}
          </span>
        </span>
      </div>
      <div class="space-y-4">
        <div v-if="!hasPrimaryLink(unidade.link) && !hasSecondaryLink(unidade.link)"
          class="relative overflow-hidden rounded-lg p-4 border border-red-300 dark:border-red-600 bg-gradient-to-r from-red-50 to-red-100 dark:from-red-800 dark:to-red-700 shadow-lg hover:shadow-xl transition">
          <div class="flex items-center gap-4">
            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
              <XCircle class="h-6 w-6 text-red-600 dark:text-white" />
            </div>
            <div class="flex-1">
              <p class="font-medium text-gray-700 dark:text-gray-200">Nenhum link disponível</p>
              <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">Fora de Operação</p>
            </div>
          </div>
        </div>
        <div v-else-if="hasPrimaryLink(unidade.link) && !hasSecondaryLink(unidade.link)"
          class="relative overflow-hidden rounded-lg p-4 border border-yellow-300 dark:border-yellow-600 bg-gradient-to-r from-yellow-50 to-yellow-100 dark:from-yellow-800 dark:to-yellow-700 shadow-lg hover:shadow-xl transition">
          <div class="flex items-center gap-4">
            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
              <CheckCircle v-if="isPrimaryUp(unidade.link?.status)" class="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
              <XCircle v-else class="h-6 w-6 text-red-600 dark:text-white" />
            </div>
            <div class="flex-1">
              <p class="font-medium text-gray-700 dark:text-gray-200">Link Primário</p>
              <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {{ unidade.link?.primaryName || 'Desconhecido' }}
                <span class="text-gray-400 dark:text-gray-500">({{ unidade.link?.primaryIP || 'N/A' }})</span>
              </p>
            </div>
            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
              <RefreshCw v-if="unidade.link?.primaryIP && unidade.link?.sync_primario === 'on'"
                class="h-6 w-6 text-blue-600 dark:text-blue-400 animate-spin" />
              <RefreshCwOff v-else-if="unidade.link?.primaryIP && unidade.link?.sync_primario === 'off'"
                class="h-6 w-6 text-red-600 dark:text-red-400" />
              <RefreshCwOff v-else class="h-6 w-6 text-gray-400 dark:text-gray-500" />
            </div>
            <button v-if="showGlobeButton(unidade.link?.status, 'primary')"
              @click="openLink(unidade.link?.dns)"
              class="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-2 shadow transition">
              <Globe class="h-5 w-5" />
            </button>
          </div>
        </div>
        <div v-else-if="!hasPrimaryLink(unidade.link) && hasSecondaryLink(unidade.link)"
          class="relative overflow-hidden rounded-lg p-4 border border-yellow-300 dark:border-yellow-600 bg-gradient-to-r from-yellow-50 to-yellow-100 dark:from-yellow-800 dark:to-yellow-700 shadow-lg hover:shadow-xl transition">
          <div class="flex items-center gap-4">
            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
              <CheckCircle v-if="isSecondaryUp(unidade.link?.status)" class="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
              <XCircle v-else class="h-6 w-6 text-red-600 dark:text-white" />
            </div>
            <div class="flex-1">
              <p class="font-medium text-gray-700 dark:text-gray-200">Link Secundário</p>
              <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {{ unidade.link?.secondaryName || 'Desconhecido' }}
                <span class="text-gray-400 dark:text-gray-500">({{ unidade.link?.secondaryIP || 'N/A' }})</span>
              </p>
            </div>
            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
              <RefreshCw v-if="unidade.link?.secondaryIP && unidade.link?.sync_secundario === 'on'"
                class="h-6 w-6 text-blue-600 dark:text-blue-400 animate-spin" />
              <RefreshCwOff v-else-if="unidade.link?.secondaryIP && unidade.link?.sync_secundario === 'off'"
                class="h-6 w-6 text-red-600 dark:text-red-400" />
              <RefreshCwOff v-else class="h-6 w-6 text-gray-400 dark:text-gray-500" />
            </div>
             <button v-if="showGlobeButton(unidade.link?.status, 'secondary')"
              @click="openLink(unidade.link?.dns)"
              class="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-2 shadow transition">
              <Globe class="h-5 w-5" />
            </button>
          </div>
        </div>
        <template v-else>
          <div :class="getLinkCardClass(unidade.link?.status, 'primary', unidade.link)"
            class="relative overflow-hidden rounded-lg p-4 border border-gray-200 dark:border-gray-700 shadow-sm transition hover:shadow-lg">
            <div class="flex items-center gap-4">
              <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
                <CheckCircle
                  v-if="hasPrimaryLink(unidade.link) && isPrimaryUp(unidade.link?.status)"
                  class="h-6 w-6 text-green-600 dark:text-green-400"
                />
                <XCircle
                  v-else-if="!hasPrimaryLink(unidade.link)"
                  class="h-6 w-6 text-gray-400 dark:text-gray-500"
                />
                <XCircle
                  v-else
                  class="h-6 w-6 text-red-600 dark:text-white"
                />
              </div>
              <div class="flex-1">
                <p class="font-medium text-gray-700 dark:text-gray-200">Link Primário</p>
                <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  {{ unidade.link?.primaryName || 'Desconhecido' }}
                  <span class="text-gray-400 dark:text-gray-500">({{ unidade.link?.primaryIP || 'N/A' }})</span>
                </p>
              </div>
              <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
                <RefreshCw v-if="unidade.link?.primaryIP && unidade.link?.sync_primario === 'on'"
                  class="h-6 w-6 text-blue-600 dark:text-blue-400 animate-spin" />
                <RefreshCwOff v-else-if="unidade.link?.primaryIP && unidade.link?.sync_primario === 'off'"
                  class="h-6 w-6 text-red-600 dark:text-red-400" />
                <RefreshCwOff v-else class="h-6 w-6 text-gray-400 dark:text-gray-500" />
              </div>
              <button v-if="showGlobeButton(unidade.link?.status, 'primary')"
                @click="openLink(unidade.link?.dns)"
                class="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-2 shadow transition">
                <Globe class="h-5 w-5" />
              </button>
            </div>
          </div>
          <div :class="getLinkCardClass(unidade.link?.status, 'secondary', unidade.link)"
            class="relative overflow-hidden rounded-lg p-4 border border-gray-200 dark:border-gray-700 shadow-sm transition hover:shadow-lg">
            <div class="flex items-center gap-4">
               <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
                <XCircle v-if="!hasSecondaryLink(unidade.link)" class="h-6 w-6 text-gray-400 dark:text-gray-500" />
                <CheckCircle v-else-if="isSecondaryUp(unidade.link?.status)" class="h-6 w-6 text-green-600 dark:text-green-400" />
                <XCircle v-else class="h-6 w-6 text-red-600 dark:text-white" />
              </div>
              <div class="flex-1">
                <p class="font-medium text-gray-700 dark:text-gray-200">Link Secundário</p>
                <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  {{ unidade.link?.secondaryName || 'Desconhecido' }}
                  <span class="text-gray-400 dark:text-gray-500">({{ unidade.link?.secondaryIP || 'N/A' }})</span>
                </p>
              </div>
              <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700">
                <RefreshCw v-if="hasSecondaryLink(unidade.link) && unidade.link?.secondaryIP && unidade.link?.sync_secundario === 'on'"
                  class="h-6 w-6 text-blue-600 dark:text-blue-400 animate-spin" />
                <RefreshCwOff v-else-if="hasSecondaryLink(unidade.link) && unidade.link?.secondaryIP && unidade.link?.sync_secundario === 'off'"
                  class="h-6 w-6 text-red-600 dark:text-red-400" />
                <RefreshCwOff v-else class="h-6 w-6 text-gray-400 dark:text-gray-500" />
              </div>
               <button v-if="showGlobeButton(unidade.link?.status, 'secondary')"
                @click="openLink(unidade.link?.dns)"
                class="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-2 shadow transition">
                <Globe class="h-5 w-5" />
              </button>
            </div>
          </div>
        </template>
      </div>
      <div class="mt-4">
        <button @click="goToUnidadeDetalhes(unidade?.link?.unidade_id || unidade?.unidade_id)"
          class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition">
          Ver detalhes da Unidade
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import {
  RefreshCwOff,
  RefreshCw,
  Building2,
  CheckCircle,
  XCircle,
  Globe,
  Monitor,      // Adicionado Monitor
  MonitorCheck, // Adicionado MonitorCheck
  MonitorX      // Adicionado MonitorX
} from 'lucide-vue-next';
import { useRouter } from 'vue-router';

const props = defineProps({
  unidade: { // Este é o selectedServer completo
    type: Object,
    required: true
  },
  status: { // Este é o selectedServer.link
    type: Object,
    required: true
  } 
});

const router = useRouter();

// LÓGICA DE STATUS UNIFICADA (baseada no objeto link)
const statusText = (linkObject) => {
  if (!linkObject) return 'Fora de Operação';

  const statusNum = linkObject.status;
  const hasPrimary = typeof linkObject.primaryIP === 'string' && linkObject.primaryIP.trim() !== '' && linkObject.primaryIP !== 'N/A';
  const hasSecondary = typeof linkObject.secondaryIP === 'string' && linkObject.secondaryIP.trim() !== '' && linkObject.secondaryIP !== 'N/A';

  if (statusNum === 1) {
    if (hasPrimary && hasSecondary) {
      return 'Pleno Funcionamento';
    } else if (hasPrimary || hasSecondary) {
      return 'Funcionamento Parcial';
    } else {
      return 'Fora de Operação';
    }
  } else if (statusNum === 2) {
    return hasPrimary ? 'Funcionamento Parcial' : 'Fora de Operação';
  } else if (statusNum === 3) {
    return hasSecondary ? 'Funcionamento Parcial' : 'Fora de Operação';
  } else if (statusNum === 4) {
    return 'Fora de Operação';
  }
  return 'Desconhecido';
};


const getStatusIcon = (categoryText) => { // Renomeado de category para categoryText para clareza
  const icons = {
    'Pleno Funcionamento': MonitorCheck,
    'Funcionamento Parcial': Monitor,
    'Fora de Operação': MonitorX,
  };
  return icons[categoryText] || Monitor;
};

const getStatusIconColor = (categoryText) => { // Renomeado de category para categoryText
  const colors = {
    'Pleno Funcionamento': 'text-green-600 dark:text-green-400',
    'Funcionamento Parcial': 'text-yellow-600 dark:text-yellow-400',
    'Fora de Operação': 'text-red-600 dark:text-red-400',
  };
  return colors[categoryText] || 'text-gray-600 dark:text-gray-400';
};

const getLinkCardClass = (linkStatusNum, linkType, linkObject) => {
  const isPrimaryPresent = hasPrimaryLink(linkObject);
  const isSecondaryPresent = hasSecondaryLink(linkObject);

  if (linkType === 'secondary' && !isSecondaryPresent) {
    return 'bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 shadow hover:shadow-lg transition opacity-60';
  }
  if (linkType === 'primary' && !isPrimaryPresent) {
     return 'bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 shadow hover:shadow-lg transition opacity-60';
  }

  // Verifica se o link específico (primário ou secundário) está UP
  let isCurrentLinkUp = false;
  if (linkType === 'primary' && isPrimaryPresent) {
    isCurrentLinkUp = (linkStatusNum === 1 || linkStatusNum === 2);
  } else if (linkType === 'secondary' && isSecondaryPresent) {
    isCurrentLinkUp = (linkStatusNum === 1 || linkStatusNum === 3);
  }
  
  if (isCurrentLinkUp) {
    return 'bg-gradient-to-r from-green-50 to-green-100 dark:from-green-800 dark:to-green-700 border border-green-300 dark:border-green-600 shadow-lg hover:shadow-xl transition';
  } else {
    // Se o link existe mas não está UP, ou se o status geral é 4
    if ((linkType === 'primary' && isPrimaryPresent) || (linkType === 'secondary' && isSecondaryPresent) || linkStatusNum === 4) {
        return 'bg-gradient-to-r from-red-50 to-red-100 dark:from-red-800 dark:to-red-700 border border-red-300 dark:border-red-600 shadow-lg hover:shadow-xl transition';
    }
  }
  // Fallback para links que existem mas cujo status não se encaixa claramente (ex: status 2 para link secundário)
  return 'bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-700 border border-gray-300 dark:border-gray-600 shadow hover:shadow-lg transition';
};


const showGlobeButton = (linkStatusNum, linkType) => {
  // O botão do globo deve aparecer se o link específico estiver ativo
  if (linkType === 'primary') {
    return (linkStatusNum === 1 || linkStatusNum === 2) && props.unidade.link?.primaryIP;
  }
  if (linkType === 'secondary') {
    return (linkStatusNum === 1 || linkStatusNum === 3) && props.unidade.link?.secondaryIP;
  }
  return false;
};


const openLink = (dns) => {
  if (dns) {
    window.open(`https://${dns}/Place`, '_blank');
  }
};

const goToUnidadeDetalhes = (unidadeId) => {
  if (unidadeId) {
    router.push(`/unidades/detalhes/${unidadeId}`);
  }
};

const isPrimaryUp = (linkStatusNum) => {
  return linkStatusNum === 1 || linkStatusNum === 2;
};

const isSecondaryUp = (linkStatusNum) => {
  return linkStatusNum === 1 || linkStatusNum === 3;
};

const hasPrimaryLink = (linkObject) => {
  const name = linkObject?.primaryName;
  const ip = linkObject?.primaryIP;
  return !!name && name.trim() !== '' && name !== 'Desconhecido' &&
         !!ip && ip.trim() !== '' && ip !== 'N/A';
};

const hasSecondaryLink = (linkObject) => {
  const name = linkObject?.secondaryName;
  const ip = linkObject?.secondaryIP;
  return !!name && name.trim() !== '' && name !== 'Desconhecido' &&
         !!ip && ip.trim() !== '' && ip !== 'N/A';
};
</script>